export default {
  COURSEWARE_LIST: 'resource-courseware.list',
  COURSEWARE_EDIT: 'resource-courseware.edit',
  COURSEWARE_VERSION: 'resource-courseware.version',
  COURSEWARE_PUBLISH: 'resource-courseware.publish'
}
